module.exports = __webpack_public_path__ + "img/gmri-otolith-id-214.8fe8a26e.png";